export default "__VITE_ASSET__F1ki8wuE__"